<template>
  <Transition name="fade">
    <button
      v-if="visible"
      type="button"
      :aria-label="$t('general.scroll_to_top')"
      class="tw:fixed tw:bottom-3 tw:right-7 tw:z-10 tw:flex tw:items-center tw:justify-center tw:w-9 tw:h-9 tw:rounded tw:border-none tw:cursor-pointer tw:shadow-md tw:transition-all tw:duration-200 hover:tw:scale-110"
      :style="{ backgroundColor: 'var(--contentcolor)' }"
      @click="scrollToTop"
    >
      <IconGoogle name="keyboard_arrow_up" size="1.25rem" color="var(--fontcolor)" />
    </button>
  </Transition>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import IconGoogle from '@/components/atomic/atoms/IconGoogle/IconGoogle.vue'

const props = withDefaults(defineProps<{
  /** CSS selector of the scrollable container */
  scrollContainer?: string
  /** Scroll threshold in px to show the button */
  threshold?: number
}>(), {
  scrollContainer: '.layout-page__overflow',
  threshold: 100,
})

const visible = ref(false)
let container: Element | null = null

function scrollToTop() {
  container?.scrollTo({ top: 0, behavior: 'smooth' })
}

function handleScroll() {
  visible.value = (container?.scrollTop ?? 0) > props.threshold
}

onMounted(() => {
  container = document.querySelector(props.scrollContainer)
  container?.addEventListener('scroll', handleScroll, { passive: true })
})

onBeforeUnmount(() => {
  container?.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
